import Map from "./Map";
import SearchBar from "./SearchBar";
const Home = () => {
    return (
        <>
         <Map />
         <SearchBar />
        </>
     );
}
 
export default Home;